import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.openOnInit = this.getData('open-on-init') ? true : false;

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {
        if(this.openOnInit) {
            this.openAccorionOnInit()
        }
    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggle(e) {
        let item = e.curTarget
        let parent = item.parentNode

        if(parent.classList.contains('is-open')) {
            this.close()
        } else {
            this.close()
            this.open(parent)
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item, duration = 0.3) {
        item.querySelector('[data-accordion="toggler"]').setAttribute('aria-expanded', 'true')

        let collapsible = item.querySelector('[data-accordion="content"]')
        item.classList.add('is-open');

        gsap.to(collapsible, duration, {
            height: this.compute(item.querySelector('[data-accordion="inner"]')).height,
            onComplete: () => {
                //this.call('update', 'Scroll');
            }
        })
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.$('item').forEach((item) => {
            item.classList.remove('is-open')
            item.querySelector('[data-accordion="toggler"]').setAttribute('aria-expanded', 'false')

            let collapsible = item.querySelector('[data-accordion="content"]')

            if(collapsible) {
                gsap.to(collapsible, 0.3, {
                    height: 0,
                    onComplete: () => {
                        this.call('update', 'Scroll');
                    }
                })
            }
        })
    }

    /**
     * open at init
     *
     * @param
     */
    openAccorionOnInit() {
        const activeItems = this.el.querySelectorAll('.is-active');

        if(activeItems.length) {
            activeItems.forEach((item) => {
                const parent = item.closest('[data-accordion="item"]')

                if(parent) {
                    this.open(parent, 0)
                }
            })
        }
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect();
    }
}
